import {
  Component,
  AfterViewInit,
  ViewChild,
  OnInit,
  Input,
} from '@angular/core';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UserService } from '@services/user/user.service';
import { LicenseANPR } from '@classes/anpr/licenseANPR';
import { User } from '@classes/user/user';
import { ClientSmartHub } from '@classes/client/client';
import { LicenseService } from '@services/anpr/license.service';
import { AddUser } from '@classes/user/userAdd';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-current-license',
  templateUrl: './current-license.component.html',
  styleUrls: ['./current-license.component.scss'],
})
export class CurrentLicenseComponent implements OnInit {
  @Input() license: LicenseANPR;
  @Input() dateBefore2weeks: boolean;
  faWarning = faExclamationCircle;

  constructor() {}

  ngOnInit(): void {}
}
